import Image from 'next/image';

import { imageLoaderForPicture } from '../../../domains/Layout/Image/URL/ImageURL';
import { Picture } from '../../../domains/Picture/Picture';
import { AverageRating } from '../../../resources/rating/domain/types/averageRating';
import { ReviewRating } from '../../../shared/components/ReviewRating/ReviewRating';
import { Button } from '../form/button/Button';
import { Ratio, RATIO } from '../ratio/Ratio';
import { Typography } from '../typography/Typography';

import style from './WemapDrawerDefaultContent.module.css';

export type WemapDrawerDefaultContentProps = {
    title: string;
    description: string | null;
    averageRating: AverageRating | null;
    picture: Picture | null;
    cta: {
        label: string;
        url: string;
    };
    onClickCta?: () => void;
};

export function WemapDrawerDefaultContent({
    title,
    description,
    averageRating,
    picture: pictureProp,
    cta,
    onClickCta,
}: WemapDrawerDefaultContentProps) {
    const picture: Picture = pictureProp ?? {
        origin: 'public_pictures',
        id: '0',
        legend: '',
        author: 'Evaneos',
    };

    function handleClickCta() {
        onClickCta?.();
    }

    return (
        <>
            <Ratio ratio={RATIO['4/3']}>
                <Image
                    className={style.picture}
                    src={picture.id}
                    alt=""
                    fill={true}
                    sizes="330px"
                    loading="lazy"
                    loader={imageLoaderForPicture(picture, {
                        aspectRatio: RATIO['4/3'],
                    })}
                />
            </Ratio>
            <div className={style.content}>
                <div className={style.body}>
                    <div className={style.head}>
                        <Typography scale="secondary-s-regular">{title}</Typography>

                        {averageRating ? (
                            <ReviewRating rating={averageRating.rating} showRatingNumber={true} />
                        ) : null}
                    </div>

                    {description ? (
                        <div
                            className={style.description}
                            dangerouslySetInnerHTML={{ __html: description }}
                        />
                    ) : null}
                </div>
                <Button priority="text" isFullWidth={true} href={cta.url} onClick={handleClickCta}>
                    {cta.label}
                </Button>
            </div>
        </>
    );
}
